var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { H2 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import Form from "@irati/ui/src/Form";
import Loading from "@irati/ui/src/Loading";
import { ValidationButton } from "@irati/ui/src/FormItem";
import { Password } from "@irati-web/fields/user";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import SetPasswordError from "@irati/ui/src/SetPasswordError";
import tracking from "@irati-tracking/platform";
var UserOnboardingSetPassword = /** @class */ (function (_super) {
    __extends(UserOnboardingSetPassword, _super);
    function UserOnboardingSetPassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            password: null,
            confirmPassword: null
        };
        _this.componentDidMount = function () {
            tracking.onBoarding("Step 2");
        };
        _this.handleChange = function (label, value) {
            var _a;
            _this.setState((_a = {},
                _a[label] = value,
                _a.saving = null,
                _a));
        };
        _this.handleSubmit = function () {
            var password = _this.state.password;
            var saving = _this.props.onComplete(password);
            _this.setState({ saving: saving });
        };
        return _this;
    }
    UserOnboardingSetPassword.prototype.render = function () {
        var _this = this;
        var _a = this.props, formatMessage = _a.formatMessage, header = _a.header;
        var _b = this.state, password = _b.password, confirmPassword = _b.confirmPassword, saving = _b.saving;
        return (React.createElement("div", null,
            React.createElement(H2, { tiny: true }, header),
            React.createElement(Para, null,
                React.createElement(FormattedMessage, { id: "onboarding.setPassword.data.header2" })),
            React.createElement(Form, null,
                React.createElement(Password, { label: "onboarding.setPassword.password.fields.label", onChange: function (value) { return _this.handleChange("password", value); }, placeholder: "onboarding.setPassword.password.fields.placeholder", value: password, hint: formatMessage({ id: "platform.password.hint" }) }),
                React.createElement(Password, { label: "onboarding.setPassword.confirmPassword.fields.label", placeholder: "onboarding.setPassword.confirmPassword.fields.placeholder", name: "confirmPassword", onChange: function (value) { return _this.handleChange("confirmPassword", value); }, value: confirmPassword, passwordToMatch: this.state.password }),
                React.createElement(Loading, { load: saving, useLoader: false }),
                React.createElement(Loading, { load: saving, useLoader: false, Error: SetPasswordError }),
                React.createElement("div", { className: "text-center push--top" },
                    React.createElement(ValidationButton, { primary: true, large: true, load: saving, loading: formatMessage({ id: "onboarding.setPassword.button.saving" }), onClick: this.handleSubmit },
                        React.createElement(FormattedMessage, { id: "onboarding.setPassword.button.continue" }))))));
    };
    return UserOnboardingSetPassword;
}(Component));
export default injectIntl(UserOnboardingSetPassword);
